import { render, staticRenderFns } from "./IdentityManager.vue?vue&type=template&id=76c94d9c&scoped=true&"
import script from "./IdentityManager.vue?vue&type=script&lang=js&"
export * from "./IdentityManager.vue?vue&type=script&lang=js&"
import style0 from "./IdentityManager.vue?vue&type=style&index=0&id=76c94d9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c94d9c",
  null
  
)

export default component.exports